export const CloseWhiteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_close_white)">
      <path
        d="M12.5255 3.97446C12.5255 3.97446 7.45097 9.04897 3.47452 13.0254M12.5255 13.0254C12.5255 13.0254 7.89279 8.39274 3.47452 3.97446"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_close_white">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
